"use client";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import styles from "./Header.module.css";

const Header = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const target = localStorage.getItem("scrollToSection");
    if (target) {
      const el = document.getElementById(target);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
      localStorage.removeItem("scrollToSection");
    }

    const scrollToTop = localStorage.getItem("scrollToTop");
    if (scrollToTop) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
      localStorage.removeItem("scrollToTop");
    }
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false); // cerrar menú al hacer clic
    }
  };

  const goToInicio = () => {
    if (window.location.pathname !== "/") {
      localStorage.setItem("scrollToTop", "true");
      navigate("/");
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setMenuOpen(false);
  };

  const handleNavigation = (sectionId) => {
    if (window.location.pathname !== "/") {
      localStorage.setItem("scrollToSection", sectionId);
      navigate("/");
      setMenuOpen(false);
    } else {
      scrollToSection(sectionId);
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.logo} onClick={goToInicio}>
        <img src="/images/logo.png" alt="De Vivo y Asociados Logo" />
      </div>

      <div
        className={`${styles.hamburger} ${menuOpen ? styles.open : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span />
        <span />
        <span />
      </div>

      <nav className={`${styles.nav} ${menuOpen ? styles.show : ""}`}>
        <button onClick={goToInicio}>INICIO</button>
        <button onClick={() => handleNavigation("nosotros")}>NOSOTROS</button>
        <button onClick={() => handleNavigation("servicios")}>SERVICIOS</button>
        <button onClick={() => handleNavigation("contacto")}>CONTACTO</button>
        <button
          onClick={() => {
            navigate("/sumatealequipo");
            setMenuOpen(false);
          }}
        >
          TRABAJA CON NOSOTROS
        </button>
      </nav>
    </header>
  );
};

export default Header;
